import React from 'react'
import { Container, Content, UserProfileChip, SettingsButton } from './styles'
import { FaGear } from 'react-icons/fa6'
import { useNavigate } from 'react-router-dom'
import { Row } from '../commons'
import { useUserStore } from '../../store/user'
import { useConfigStore } from '../../store/config'
import { useTheme } from 'styled-components'

export interface HeaderProps {
  title?: string
  handleModal?: () => void
}

const Header: React.FunctionComponent<HeaderProps> = () => {
  const nav = useNavigate()
  const theme: any = useTheme()
  const { user } = useUserStore()
  const { config } = useConfigStore()

  const primaryColor = theme?.colors?.primary || '#2c30af'

  return (
    <Container>
      <Content>
        {/* Lado Esquerdo: Identidade Visual */}
        <Row style={{ gap: 12, alignItems: 'center' }}>
          <div
            style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
            onClick={() => nav('/documents')}
          >
            {config?.logo ? (
              <div
                style={{
                  background: '#ffffff',
                  padding: '3px 8px',
                  borderRadius: 6,
                  display: 'flex',
                  alignItems: 'center',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                }}
              >
                <img
                  src={config.logo}
                  alt="Logo"
                  style={{ height: 26, maxHeight: 30, objectFit: 'contain' }}
                />
              </div>
            ) : (
              <div
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  background: '#ffffff',
                  color: primaryColor,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 800,
                  fontSize: 15,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                }}
              >
                G
              </div>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
              <span style={{ fontSize: '15px', fontWeight: 700, color: '#ffffff', letterSpacing: '-0.02em' }}>
                {config?.platformName || 'GED ASP'}
              </span>
              <span style={{ fontSize: '10px', color: 'rgba(255, 255, 255, 0.8)', fontWeight: 500 }}>
                Gestão Eletrônica de Documentos
              </span>
            </div>
          </div>
        </Row>

        {/* Lado Direito: Perfil do Usuário Logado + Configurações */}
        <Row style={{ gap: 12, alignItems: 'center' }}>
          <UserProfileChip onClick={() => nav('/profile')} title="Visualizar Meu Perfil">
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: '#ffffff',
                color: primaryColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 13,
                fontWeight: 800,
              }}
            >
              {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: '#ffffff' }}>
                {user?.name ? (user.name.length > 20 ? `${user.name.substring(0, 18)}...` : user.name) : 'Usuário'}
              </span>
              <span style={{ fontSize: 10, color: 'rgba(255, 255, 255, 0.8)', fontWeight: 500 }}>
                {user?.role === 'admin'
                  ? 'Administrador'
                  : user?.role === 'manager' || user?.manager
                  ? 'Gerente'
                  : 'Usuário'}
              </span>
            </div>
          </UserProfileChip>

          <SettingsButton onClick={() => nav('/config')} title="Configurações do Sistema">
            <FaGear size={16} color="#ffffff" />
          </SettingsButton>
        </Row>
      </Content>
    </Container>
  )
}

export default Header
